import { FilterOperators, type FilterOperator } from '../../types';

/**
 * KIR-5098: the operator-dropdown value that selects a column's alternate
 * filter (AlternateColumnFilter). UI-only — never sent to the API: applying it
 * emits the alternate field with its own operator. BETWEEN is safe because a
 * column with an alternate filter never offers BETWEEN itself.
 */
export const ALTERNATE_FILTER_OPERATOR: FilterOperator =
  FilterOperators.BETWEEN;
